export default __webpack_public_path__ + "static/about-me-3ecb57ce083a625f96b9461e9d5efc72.jpg";